import styled, { css } from 'styled-components'
import { fadeInAndScaleUp, fadeIn } from '../../Styles/Animations'
import { zIndex } from '../../Styles/Metrics'

export const Backdrop = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transition: all .2s;
  z-index: ${zIndex.modal};
  background-color: ${({ theme }) => theme.backdrop};
  animation: ${fadeIn} 200ms ease-in;
  ${({ animateOut }) => animateOut && css`opacity: 0;`}

  @supports (-webkit-backdrop-filter: blur(10px)) or (backdrop-filter: blur(10px)) {
    -webkit-backdrop-filter: blur(10px);
    backdrop-filter: blur(10px);
    background-color: ${({ theme }) => theme.backdrop};
  }
`

const AnimateOutStyle = css`
  opacity: 0;
  transform: scale(0.7);
`

export const ModalWrapper = styled.div`
  background-color: ${({ theme }) => theme.snow};
  width: 90%;
  max-width: ${({ lg, sm }) => lg ? 80 : (sm ? 35 : 50)}rem;
  overflow: auto;
  min-height: 20rem;
  max-height: 70%;
  border-radius: 4px;
  padding: 3rem 2rem 2rem 2rem;
  box-shadow: 0 2rem 4rem ${({ theme }) => theme.backdrop};
  animation: ${fadeInAndScaleUp} 200ms ease-in;
  transition: all .2s;
  position: relative;
  margin: 20rem auto 0 auto;
  ${({ animateOut }) => animateOut && AnimateOutStyle}
`

export const ButtonWrapper = styled.div`
  position: absolute;
  top: 1rem;
  right: 1rem;
`



// WEBPACK FOOTER //
// ./src/Components/Modal/styles.js